import PreloaderClass from '../common/PreloaderClass';
import FormValidationClass from '../common/FormValidationClass';
import FormValidationMessagesClass from '../common/FormValidationMessagesClass';
import { fetchRequestSend } from '../../helpers/common-helpers';

export default class SignUpHS {
    constructor() {
        this.formID = 'hs_signup-form';
        this.form = null;

        this.init();
    }

    init() {
        this.form = document.getElementById(this.formID);

        if (this.form) {
            this.form.addEventListener('submit', this.handleFormSubmit.bind(this));
        }
    }

    handleFormSubmit(e) {
        e.preventDefault();

        const isFormValid = new FormValidationClass(this.formID).init();
        const messagesClass = new FormValidationMessagesClass();

        if (isFormValid) {
            PreloaderClass.forPopup(this.formID);
            messagesClass.hideErrorForForm(this.formID);

            const formData = new FormData(this.form);

            fetchRequestSend(signUpHsUrl, 'POST', formData).then(response => {
                const { status, redirect, message } = response;

                PreloaderClass.stop();

                if (redirect && message) {
                    if (status) {
                        messagesClass.showSuccessForForm(this.formID, message);
                    } else {
                        messagesClass.showErrorForForm(this.formID, message);
                    }

                    setTimeout(() => {
                        window.location.href = redirect;
                    }, 2000);
                }
            });
        }
    }
}
